module.exports = __webpack_public_path__ + "img/order_status_end@2x.05a34858.png";